import Swiper from 'swiper/bundle';
import 'swiper/css/navigation';
import 'swiper/css/bundle';
import 'swiper/css/pagination';


class Carousel {
    constructor(section) {
        this.section = section
    }

    init() {
        console.log('Carousel Initialization')
        const swiper = new Swiper(this.section, this.options);
    }

    get options() {
        return this.section.getAttribute('data-carousel-options') ? JSON.parse(this.section.getAttribute('data-carousel-options')) : {}
    }
}

export default Carousel;